/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".timeline-layer-remove[_ngcontent-%COMP%]{position:absolute;top:4px;right:4px;padding:0;border:none;background:0 0;font-size:20px;color:#d2d2d2}.timeline-layer-remove[_ngcontent-%COMP%]:focus, .timeline-layer-remove[_ngcontent-%COMP%]:hover{color:#ea3d3d}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/rec/timeline/timeline-layer/timeline-layer-remove/timeline-layer-remove.component.styl.shim.ngstyle.js.pre-build-optimizer.js